export default __webpack_public_path__ + "image/no-result-7d59e234.png";